/**
 * 検索条件に一致する拠点が0件のときに、拠点一覧の代わりに表示する空き状況表示。
 */
export function RoomTypeSearchEmptyState() {
  return (
    <div className="flex flex-col items-start pt-[16px] pb-[16px]">
      <div className="flex items-start px-[16px]">
        <h3 className="dx-headline-2-mobile text-dx-text-placeholder">
          利用できるお部屋が見つかりません
        </h3>
      </div>
      <div className="flex items-start px-[16px]">
        <p className="dx-body-2 text-dx-text-placeholder">
          条件を変更してもう一度お試しください
        </p>
      </div>
    </div>
  );
}
